<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

// 定义常量
const colors = [
  "#91FFDF",
  "#91FFDF",
  "#91FFDF",
  "#91FFDF",
  "#91FFDF",
  "#91FFDF",
];
const data = [10, 20, 10, 8, 7, 7];

// 创建ECharts配置对象
const option = {
  // backgroundColor: "#002653",
  grid: {
    top: "5%",
    left: "5%",
    right: "12%",
    bottom: "20%",
  },
  xAxis: {
    show: false,
    type: "value",
  },
  yAxis: {
    type: "category",
    align: "left",
    padding: [0, 0, 40, 10],
    axisLabel: {
      color: "#FFF",
      fontSize: 30,
      width: 80,
      padding: [0, 0, 50, 8],
      align: "left",
      formatter: (params) => {
        return `${params}`;
      },
      rich: {
        value: {
          color: "#fff",
          fontSize: 30,
          fontWeight: 500,
        },
      },
    },
    axisTick: "none",
    inverse: true,
    axisLine: {
      show: false,
    },
    data: ["空气温度", "空气湿度", "PH值", "氮", "磷", "钾"],
  },
  series: [
    {
      type: "pictorialBar",
      barWidth: 10,
      legendHoverLink: false,
      silent: true,
      symbolRepeat: true,
      symbolMargin: 7,
      symbol: "rect",
      symbolClip: true,
      symbolSize: [10, 28],
      symbolOffset: [10, 10], // 边框相对于柱体的偏移量
      symbolPosition: "start",
      barGap: "10%", // 柱形间距离，默认为'30%'，可设为像素值如'20'，也可以是百分比字符串如'20%'
      barCategoryGap: "30%", // 类目间的柱形间隔，默认为'20%'，同样可设为像素值或百分比字符串

      label: {
        show: true,
        position: "right",
        inside: false, // 确保标签在柱子外部显示
        distance: 15,
        formatter: "{c} %",
        fontSize: 30,
        color: "#FFF",
      },
      itemStyle: {
        // 添加边框颜色和宽度
        borderColor: "#fff", // 边框颜色
        borderWidth: 5, // 边框宽度，单位为像素
        color: function (params) {
          return colors[params.dataIndex];
        },
      },
      data: data,
    },
  ],
};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);

    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
